export default {"src":"/_next/static/media/earth.b1e02455.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};